import React from "react";
import { PROPERTIES, SELLERS } from "../../consts/tables";
import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import SellerInfo from "./SellerInfo";
import SellerCompanyInfo from "./SellerCompanyInfo";
import { dateISOtoUS, dateUStoISO } from "../../date-converter";
import Drawer from "../Drawer";
import PropertyDrawer from "../PropertyDrawer/PropertyDrawer";
import PropertyInfo from "../CRUDProperty/components/PropertyInfo";
import {formatAddress, formatNumber} from "../../utils";
import { priceToString } from "../CRUDProperty/CRUDProperty";
import request from 'arcdynamic-request';
import { GET_PROPERTIES } from "../Graphql/Queries/propertiesQuery";
import { GET_SELLERS, GET_SELLERS_BY_ID } from "../Graphql/Queries/SellersQuery";
import { ApolloConsumer } from "@apollo/client";
import { CREATE_UPDATE_PROPERTY, CREATE_UPDATE_SELLERS } from "../Graphql/Mutations/SellerMutation";
import filter from "../../filter";
import CRUDOLD from "../CRUD/CRUDOLD";
import { CREATE_OR_UPDATE_CONTACTS_SELLERS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_SELLERS_LIST_QUERY, GET_SELLER_BY_CONTACTID } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData, mutateData } from "../Service/graphQlService";



const limit = 20000;

const dateProps = [
  "LAST_MODIFIED"
];

const propertyPriceProps = [
  'LIST_PRICE',
  'HSC_PRICE'
];

function convertPropertyDataToForm(dbData) {
  const data = {...dbData};

  propertyPriceProps
    .filter((key) => data[key])
    .forEach((key) => {
        const num = Number(data[key]);
        if (num === num) {
            data[key] = formatNumber(num,true);
        }
    }); 

  return data;
}

function convertDataToForm(dbData) {
  const data = {...dbData};
  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateISOtoUS(data[key]);
          if (str !== false)
              data[key] = str;
      });
  return data;
}

function convertFormToData(formData) {
  const data = {...formData};

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateUStoISO(data[key]);
          if (str !== false)
              data[key] = str;
      });

  propertyPriceProps.forEach((key) => {
          const num = priceToString(data[key]);
          if (num !== false)
              data[key] = num;
      });      


  return data;
}

export default class CRUDSeller extends React.Component {
  drawerComponentRef;

  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists:false,
      errorTabs: [],
      users:[],
      currentTab: 0,
      showDrawer:false,
      offMarketProperty:null,
      updateSeller: false,
      updateProperty: false,
      viewMode: this.props.edit || false,
      resetDrawer: false
    };
    this.client = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handlePropertyChangeInput = this.handlePropertyChangeInput.bind(this);
    this.handlePropertyChangeDropdown = this.handlePropertyChangeDropdown.bind(this);
    this.savedNewItem = this.savedNewItem.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);

    this.drawerComponentRef = React.createRef();
  }
  
  savedNewItem(newData) {
    const state = {
      offMarketProperty: {...newData},
    };
    this.setState(state, () => this.toggleDrawer());
    this.fetch(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.fetch(this.props.params.id);
  }

  closeDrawer() {
    this.setState({showDrawer: false, resetDrawer: true});
  }

  toggleDrawer() {
    this.setState((prevState) => ({showDrawer: !prevState.showDrawer, resetDrawer: false}));
  }

  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: {},
      });
      return;
    }
   
  const token = localStorage.getItem('authToken');
  const filterData =  [  {
    status: 'Off Market'
  },
  {
    seller_id : id
  },
]
    // return Promise.all([
    //   getData({
    //     tableCode: SELLERS,
    //     options: {
    //       filter: [
    //       {
    //         text: id,
    //         code: "ARCIMEDES_ROW_ID",
    //         type: "exact",
    //       },
    //       ],
    //     },
    //   }),
    //   getData({
    //     tableCode: PROPERTIES,
    //     options: {
    //       filterType:'and',
    //       filter: [
    //         {
    //           text: 'Off Market',
    //           code: "STATUS",
    //           type: "exact",
    //         },
    //         {
    //           text: id,
    //           code: "SELLER_ID",
    //           type: "exact",
    //         },
    //       ],
    //       order: [{ code: 'ARCIMEDES_ROW_ID', type: 'asc'  }],
    //       limit: { count: 3, offset: 0 },
    //     },
        
    //   })
    // ]).
    return Promise.all([
      // this.client.query({
      //   query: GET_SELLERS_BY_ID,
      //   variables: { arcimedesRowId : id },
      //   fetchPolicy: "no-cache",
      //   context: {
      //     headers: {
      //       authorization: `Bearer ${token}`,
      //     },
      //   },
      // }),
      fetchData(GET_SELLER_BY_CONTACTID, { contactid:parseInt(id)}),
      fetchData(GET_PROPERTIES,{ filters: [
        {
          "STATUS": "Off Market",
          "SELLER_ID": id
        }
      ] })
      // this.client.query({
      //           query: GET_PROPERTIES,
      //           variables: { filters: [
      //             {
      //               "STATUS": "Off Market",
      //               "SELLER_ID": id
      //             }
      //           ] },
      //           fetchPolicy: "no-cache",
      //           context: {
      //             headers: {
      //               authorization: `Bearer ${token}`,
      //             },
      //           },
      //         })
            ]).then((res) => {
      if (res[0] && res[0].data.getContactByContactid.success && res[0].data.getContactByContactid.contact
        && res[1]  && Array.isArray(res[1].data.getProperties.properties) && res[1].data.getProperties.properties.length) {
        this.setState({
          data: res[0].data.getContactByContactid.contact,
          offMarketProperty: convertPropertyDataToForm(res[1].data.getProperties.properties),
          original: res[0].data.getContactByContactid.contact,
          error: null,
        });
      } 
      else if(res[0] && res[0].data.getContactByContactid.success){
        this.setState({
          data: res[0].data.getContactByContactid.contact,
          original:res[0].data.getContactByContactid.contact ,
          error: null,
        });
      }
      else {
        this.setState({
          data: false,
          offMarketProperty: false,
          error: res[0].data.getContactByContactid.message ? res[0].data.getContactByContactid.message  : "Unidentified Error",
        });
      }
    });
  }

  fetchUserData(offset) {
    const query = { ...offset };
		const options = filter(query, 'sellers');
		options.param.limit = limit;
		options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

		var pageParams = {
			page: query.page ? Number(query.page) : 1,
			pageSize: limit
		}
    // const options = {
    //   limit: {
    //     count: limit,
    //     offset: offset * limit,
    //   },
    //   column: [
    //     'ARCIMEDES_ROW_ID',
    //     'FIRST_NAME',
    //     'LAST_NAME',
    //     'EMAIL',
    //     'PHONE',
    //     'DELETED',
    //   ]
    // };
    // request(arc.path.api, {
    //   service: 'arcimedes',
    //   action: 'open.datasource.table.Data.getData',
    //   params: ['code', SELLERS, options],
    // })
  //   const token = localStorage.getItem('authToken');
  //   this.client.query({
  //     //query: GET_CONTACT_SELLERS_LIST_QUERY, variables: { type: "Seller",pageOptions: pageParams,filters:[], sortOptions: [] }, fetchPolicy: "no-cache",
  //     query: GET_CONTACT_SELLERS_LIST_QUERY, variables: { type: "Seller",pageOptions: pageParams,filters:[], sortOptions: [] }, fetchPolicy: "no-cache",
  //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
  //     context: {
  //         headers: {
  //             authorization: `Bearer ${token}`, // Bearer token added here
  //         },
  //     },
  // })
 fetchData(GET_CONTACT_SELLERS_LIST_QUERY, {type: "Seller",pageOptions: pageParams,filters:[], sortOptions: [] })
    .then(res => {
      this.setState(prevState => {
        const users = prevState.users.concat(res.data.getContacts.data);
        return {
          users,
        };
      });
      if (res.data.length >= limit) {
        this.fetchUserData(++offset);
      } else {
        // const isExists = this.state.users.filter(u => (this.state.data.ARCIMEDES_ROW_ID != undefined && this.state.data.ARCIMEDES_ROW_ID != null) ? u.ARCIMEDES_ROW_ID != this.state.data.ARCIMEDES_ROW_ID: true ).find((e) => {
        //   return (
        //     (e.FIRST_NAME != null && e.FIRST_NAME.toLowerCase()) == (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
        //     (e.LAST_NAME != null && e.LAST_NAME.toLowerCase()) == (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase()) )
        // });
        // const isExists = res.data.getSellers.data.some((seller) => {
        //   const sellerFirstName = seller.FIRST_NAME ? seller.FIRST_NAME.toLowerCase() : null;
        //   const sellerLastName = seller.LAST_NAME ? seller.LAST_NAME.toLowerCase() : null;
        //   const stateFirstName = this.state.data.FIRST_NAME ? this.state.data.FIRST_NAME.toLowerCase() : null;
        //   const stateLastName = this.state.data.LAST_NAME ? this.state.data.LAST_NAME.toLowerCase() : null;
        const isExists = res.data.getContacts.data.some((seller) => {
          const sellerFirstName = seller.first_name ? seller.first_name.toLowerCase() : null;
          const sellerLastName = seller.last_name ? seller.last_name.toLowerCase() : null;
          const stateFirstName = this.state.data.first_name ? this.state.data.first_name.toLowerCase() : null;
          const stateLastName = this.state.data.last_name ? this.state.data.last_name.toLowerCase() : null;
          
          return (
            sellerFirstName === stateFirstName &&
            sellerLastName === stateLastName &&
            //seller.ARCIMEDES_ROW_ID !== this.state.data.ARCIMEDES_ROW_ID
            seller.arcimedes_row_id !== this.state.data.arcimedes_row_id
      
          );
        });
        this.setState({
          isExists: !!isExists,
        })
        if (isExists) {
          return
        }
        else {
          this.setState({ viewMode: true }, () => this.saveData());
        }
      }
    });
  }


  async handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      // !this.state.data.FIRST_NAME ||
      // !this.state.data.LAST_NAME
      !this.state.data.first_name ||
      !this.state.data.last_name
    ) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      if (this.state.isBusy || this.state.viewMode === true) return;
      this.setState({ errorTabs: [] });
      this.fetchUserData(0);
    }


  }

  handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value
      }),
      updateSeller:true
    });
  }

  handleChangeDropdown(query, queryType, x, key) {
    const data = {...this.state.data};
        if (key === 'status') {
          //data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
            data.last_modified = new Date().toLocaleDateString("en-US");
        }
      data[key] = query[key];
      this.setState({
        data:data,
        updateSeller:true
      });
  }

  handlePropertyChangeInput(key, value) {
    this.setState({
      offMarketProperty: Object.assign(this.state.offMarketProperty, {
        [key]: value
      }),
      updateProperty:true
    });
  }

  handlePropertyChangeDropdown(query, queryType, x, key) {
    const data = {...this.state.offMarketProperty};
    data[key] = query[key];
    this.setState({
      offMarketProperty:data,
      updateProperty:true
    });
  }

  saveData(directDelete=false) {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    const offMarketProperty = convertFormToData(this.state.offMarketProperty);
    //offMarketProperty.ADDRESS = offMarketProperty.ADDRESS ? formatAddress(offMarketProperty.ADDRESS) : '';
    offMarketProperty.address = offMarketProperty.address ? formatAddress(offMarketProperty.address) : '';

    Object.keys(this.state.data).forEach((k) => {
      if (!this.state.data[k] || k === "undefined") {
        const newData = { ...this.state.data };
        delete newData[k];
        this.setState({ data: newData });
      }
    });
    // if(this.state.data.COMPANY_ZIP === ""){
    //   delete this.state.data.COMPANY_ZIP
    if(this.state.data.company_zip === ""){
      delete this.state.data.company_zip
    }
    delete this.state.data.__typename
    delete this.state.data.arcimedes_created
    delete this.state.data.arcimedes_created_by
    delete this.state.data.arcimedes_modified
    delete this.state.data.arcimedes_modified_by
    // delete this.state.data.ARCIMEDES_CREATED
    // delete this.state.data.ARCIMEDES_CREATED_BY
    // delete this.state.data.ARCIMEDES_MODIFIED
    // delete this.state.data.ARCIMEDES_MODIFIED_BY
const inputData = {...this.state.data, 
          contact_type: "Seller"};
              //this.setState({ data: inputData });
    const token = localStorage.getItem('authToken');
    const input=convertFormToData(inputData);
    return Promise.all([
        (this.state.updateSeller || directDelete)&&
      //   manageData({ tableCode: SELLERS, 
      //     data: [convertFormToData(this.state.data)],
      //   }),
      //   this.state.updateProperty &&
      //   manageData({tableCode: PROPERTIES,
      //     data: [offMarketProperty]})
      //this.client.mutate({mutation:CREATE_UPDATE_SELLERS, variables:{input:[convertFormToData(this.state.data)]},
      // this.client.mutate({mutation:CREATE_OR_UPDATE_CONTACTS_SELLERS, variables:{input:convertFormToData(inputData)},
      // fetchPolicy: "no-cache",
      // context: {
      //   headers: {
      //     authorization: `Bearer ${token}`,
      //   },
      // }}),
      mutateData(CREATE_OR_UPDATE_CONTACTS_SELLERS,{input}),
      // this.client.mutate({mutation:CREATE_UPDATE_PROPERTY, variables:{input:[offMarketProperty]},
      // fetchPolicy: "no-cache",
      // context: {
      //   headers: {
      //     authorization: `Bearer ${token}`,
      //   },
      // }})

      ])

      .then((res) => {
        //if (res[0] && res[0].data.createOrUpdateSellers.success  ) {
        if (res[0] && res[0].data.createOrUpdateContact.success  ) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
              updateProperty: false,
              updateSeller: false,
              offMarketProperty: offMarketProperty,
            },
            () => {
              if (!this.props.edit) {
                browserHistory.push({
                  //pathname: `/seller/${res[0].data.createOrUpdateSellers.data[0].ARCIMEDES_ROW_ID}`,
                  pathname: `/seller/${res[0].data.createOrUpdateContact.contact.contact_id}`,
                });
              }
            }
          );
          window.scrollTo(0, 0);
        } else {
            this.setState({
              isBusy: null,
              //error: res[0] && res[0].data.createOrUpdateSellers.message ? res[0].data.createOrUpdateSellers.message : (this.state.updateSeller ? "Unspecified error":"No changes were made"),
              error: res[0] && res[0].data.createOrUpdateContact.message ? res[0].data.createOrUpdateContact.message : (this.state.updateSeller ? "Unspecified error":"No changes were made"),
              updateProperty: false,
              updateSeller: false,
            });
        }
      }
    );
  }
  

  render() {
    const data = this.state.data;
    const { edit , isSuper} = this.props;
    const tabsData = [
      {
        name: "SELLER",
        renderedComponent: (
            <SellerInfo
                data={data}
                isExists={this.state.isExists}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                //deleted={data && data.DELETED === "1"}
                deleted={data && data.deleted === "1"}
                toggleDrawer={this.toggleDrawer}
                handleParentDropdownChange={this.handleChangeDropdown}
            />
        ),
      },
      {
        name: "SELLER COMPANY",
        renderedComponent: (
            <SellerCompanyInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                //deleted={data && data.DELETED === "1"}
                deleted={data && data.deleted === "1"}
            />
        ),
      }
    ];
    //if (data && data.STATUS === 'Off-Market' && this.state.offMarketProperty){      
    if (data && data.status === 'Off-Market' && this.state.offMarketProperty){      
      Object.keys(this.state.offMarketProperty).forEach((e,index)=>{
        tabsData.push({
          name: "PROPERTY"+'\n'+(index+1),
          renderedComponent: (
            this.state.offMarketProperty[e] ?
                  <PropertyInfo
                      data={convertFormToData(this.state.offMarketProperty[e])}
                      handleChangeInput={this.handlePropertyChangeInput}
                      handleChangeDropdown={this.handlePropertyChangeDropdown}
                      viewMode={this.state.viewMode}
                      //deleted={data && data.DELETED === "1"}
                      deleted={data && data.deleted === "1"}
                      isOffMarket={true}
                  />
                  :
                  <div className='no-results'>The seller doesn't have any Off Market property.</div>
          ),
        });
      });
    }

    return (
      <ApolloConsumer>
        {client => {
          if(!this.client){
            this.client = client
          }
          return(
      <CRUDOLD
        tabsData={tabsData}
        isExists={this.state.isExists}
        router={this.props.router}
        backLink={`${arc.path.base}sellers`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={()=>this.saveData(true)}
        type="seller"
        backName="SELLERS"
        //title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        title={data && `${data.first_name} ${data.last_name}`}
        isSuper = {isSuper}
        drawer={
          <Drawer
              isOpen={this.state.showDrawer}
              reff={this.drawerComponentRef}
              closeDrawer={this.closeDrawer}
          >
              <PropertyDrawer 
                userData = {this.props.userData}
                savedNewItem={this.savedNewItem}
                closeDrawer={this.closeDrawer}               
                isOffMarket={true}
                sellerId={this.props.params.id}  
                resetDrawer={this.state.resetDrawer}
              />
          </Drawer>
      }
      />
          )
        }}
      </ApolloConsumer>
      
    );
  }
}
